import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import NoChatsIcon from '../../../../assets/icons/empty-state/no-chats.svg';
import {NoResultsView} from '../../../../components/NoResultsView';
import * as S from './styles';

export const ChannelsListEmptyState: FC<Props> = ({isSearch, tab}) => {
  const {t} = useI18n();

  let text = t('shared:you_dont_have_started_chats');

  switch (tab) {
    case 'course_individual_archived':
      text = t('shared:you_dont_have_archived_chats');
      break;
    default:
      break;
  }

  if (isSearch) {
    text = t('shared:nothing_found');
  }

  return (
    <S.Container>
      <NoResultsView icon={NoChatsIcon} text={text} />
    </S.Container>
  );
};
